import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

/** Class that contains some validators that can be use by the entire application */
export class CustomValidators {

   /**
    * Pattern Validator
    * The custom validator will accept the validation RegExp expression and the validation error object 
    * that has to be returned if an error happened.
    * 
    * ES. patternValidator(/\d/, { hasNumber: true }),
    */
   static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } => {
         if (!control.value) {
            // If control is empty return no error
            return null;
         }

         // Test the value of the control against the regexp supplied
         const valid = regex.test(control.value);

         // If true, return no error (no error), else return error passed in the second parameter
         return valid ? null : error;
      };
   }

   /**
    * Password Match Validator
    * CustomValidator to check whether our password and confirm password are a match.
    * Add a second customValidator, called passwordMatchValidator and add the following code
    * @param control
    */
   static passwordMatchValidator(control: AbstractControl) {
      // Get password from our password form control
      const password: string = control.get('password').value; 

      // Get password from our confirmPassword form control
      const confermaPassword: string = control.get('conferma_password').value; 

      // Check if the passwords match
      if (password !== confermaPassword) {
         // If they don't match, set an error in our confirmPassword form control
         control.get('conferma_password').setErrors({ NoPasswordMatch: true });
      }
   }

   /** 
    * atLeastOneValidator
    * Custom validator to check if there's at leat une value
    * */
   static atLeastOneValidator(controlGroup: FormGroup) {
      const controls = controlGroup.controls;
      if (controls) {
         const theOne = Object.keys(controls).find(key => controls[key].value !== null);
         if (!theOne) {
            return { almeno_uno: { messaggio: 'Ci deve essere almeno un valore popolato' } };
         }
      }
      return null;
   }

   /**
    * atLeastOneValidatorCheckbox 
    * Custom validator to check if there's at leat une value
    * */
   static atLeastOneValidatorCheckbox(controlGroup: FormGroup) {
      const controls = controlGroup.controls;
      if (controls) {
         const theOne = Object.keys(controls).find(key => controls[key].value !== false);
         if (!theOne) {
            return { almeno_uno: { messaggio: 'Ci deve essere almeno un valore selezionato' } };
         }
      }
      return null;
   }


   /** 
   * onlyNumbers
   * Custom validator to check if the input field contains only numeric values
   * */
   static onlyNumbers(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {

         let numbers = new RegExp(/^[0-9]+$/);

         let valid = numbers.test(control.value);

         control.setErrors({ onlyNumbers: true });
         return valid ? null : { onlyNumbers : true };
         
      };
   } // onlyNumbers()


   /** 
   * onlyNumbers
   * Custom validator to check if the input field contains only numeric values
   * */
   static formatoCodiceFiscale(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {

         let numbers = new RegExp(/^[0-9]+$/);
         let letters = new RegExp(/^[A-Za-z]+$/);

         let cfis = control.value;
         
         let valid = false;
         
         if(cfis != null){
            // SRMFRC80A01F205B
            let cognome_nome = cfis.substring(0, 6);
            cfis = cfis.substring(6);

            let anno = cfis.substring(0, 2);
            cfis = cfis.substring(2);

            let mese = cfis.substring(0, 1);
            cfis = cfis.substring(1);

            let giorno = cfis.substring(0, 2);
            cfis = cfis.substring(2);

            let provincia_char = cfis.substring(0, 1);
            cfis = cfis.substring(1);

            let provincia_num = cfis.substring(0, 3);
            cfis = cfis.substring(3);

            let codice_verifica = cfis.substring(0, 1);
            cfis = cfis.substring(1);

            valid = letters.test(cognome_nome)
               && numbers.test(anno)
               && letters.test(mese)
               && numbers.test(giorno)
               && letters.test(provincia_char)
               && numbers.test(provincia_num)
               && letters.test(codice_verifica);

            // Gestione casi di codici fiscali noti che per qualche motivo differiscono dallo standard e che dobbiamo accettare ugualmente
            if(provincia_num == '3P0'){ valid = true; }

         }

         control.setErrors({ formatoCodiceFiscale: true });
         return valid ? null : { formatoCodiceFiscale : true };
         
      };
   } // formatoCodiceFiscale()


   


}